import { snapshot } from 'valtio'
import { buildAxiosInstance } from '../utils/apiUtils'
import { creditCardListProxy } from '../proxies/creditCardListProxy'
import { virtualTerminalProxy } from '../../routes/app/virtual-terminal/index/virtualTerminalProxy'
import { customerProxy } from '../proxies/customerProxy'
import { type GlobalCustomerAchType } from '../types/GlobalCustomerAchType'

interface Response {
  data: {
    achAccounts: GlobalCustomerAchType[]
  } | null
  error: string | null
}

export async function executeCustomerAchSearchForCustomerDetail (): Promise<void> {
  const { customer } = snapshot(customerProxy)
  if (!customer?.id) {
    return
  }
  customerProxy.apiCallCustomerAchSearch.loading = true
  customerProxy.apiCallCustomerAchSearch.error = null
  try {
    const response = await buildAxiosInstance().post<Response>('/api/ach_accounts/search', {
      customerId: String(customer?.id)
    })
    if (response.data.data) {
      customerProxy.achAccounts = response.data.data.achAccounts
    } else {
      customerProxy.apiCallCustomerAchSearch.error = response.data.error
    }
  } catch (e) {
    if (e instanceof Error) {
      customerProxy.apiCallCustomerAchSearch.error = e.message
    }
  } finally {
    customerProxy.apiCallCustomerAchSearch.loading = false
  }
}

export async function executeCustomerAchSearch (): Promise<void> {
  creditCardListProxy.apiCallCustomerAchSearch.loading = true
  creditCardListProxy.apiCallCustomerAchSearch.error = null
  const { customer } = snapshot(virtualTerminalProxy)
  try {
    const response = await buildAxiosInstance().post<Response>('/api/ach_accounts/search', {
      customerId: String(customer?.id)
    })
    if (response.data.data) {
      creditCardListProxy.achAccounts = response.data.data.achAccounts
    } else {
      creditCardListProxy.apiCallCustomerAchSearch.error = response.data.error
    }
  } catch (e) {
    if (e instanceof Error) {
      creditCardListProxy.apiCallCustomerAchSearch.error = e.message
    }
  } finally {
    creditCardListProxy.apiCallCustomerAchSearch.loading = false
  }
}
